export const getState = (state) => state;

// Session Context
export const getSessionContext = (state) => getState(state)?.sessionContext;
export const getLoggedIn = (state) => !!getSessionContext(state)?.loggedIn;
export const getLoggedUser = (state) =>
  getSessionContext(state)?.loggedUser || null;

// Search Context
export const getSearchContext = (state) => getState(state)?.searchContext;
export const getSearchLoading = (state) =>
  getSearchContext(state)?.isLoading || false;
export const getSearchFiltersLoading = (state) =>
  getSearchContext(state)?.filtersLoading || false;
export const getAppliedFilters = (state) =>
  getSearchContext(state)?.appliedFilters || {};
export const getSearchFilters = (state) =>
  getSearchContext(state)?.searchFilters || {};
export const getSearchType = (state) =>
  getSearchContext(state)?.searchType || {};
export const getCurrentAppliedFilters = (state) =>
  getAppliedFilters(state)?.[getSearchType(state)?.id || "all"] || [];
export const getCurrentSearchFilters = (state) =>
  getSearchFilters(state)?.[getSearchType(state)?.id || "all"] || [];
export const getQueryValue = (state) => getSearchContext(state)?.query || null;
export const getSearchResults = (state) =>
  getSearchContext(state)?.searchResults || {};
export const getSearchResultsType = (state) =>
  getSearchContext(state)?.searchResultsType || "all";
export const getCurrentSearchPeriod = (state) => {
  const searchType = state.searchContext.searchType?.id;
  return state.searchContext.searchPeriod[searchType];
};
export const getSelectedPersonFilter = (state) => {
  const searchType = state.searchContext.searchType?.id;
  return state.searchContext.selectedPersonFilter[searchType] || "";
};

// Model Type Filters
export const getSearchModelType = (state) =>
  getSearchContext(state)?.searchModelType || "all";
export const getModelTypeSearchFilters = (state) =>
  getSearchContext(state)?.modelTypeSearchFilter || {};
export const getModelTypeAppliedFilters = (state) =>
  getSearchContext(state)?.modelTypeAppliedFilters || {};
export const getCurrentModelTypeFilters = (state) => {
  const modelType = getSearchModelType(state);
  return getModelTypeSearchFilters(state)?.[modelType] || [];
};
export const getCurrentModelTypeAppliedFilters = (state) => {
  const modelType = getSearchModelType(state);
  return getModelTypeAppliedFilters(state)?.[modelType] || [];
};

// UI Context
export const getUIContext = (state) => getState(state)?.uiContext;
export const getErrors = (state) => getUIContext(state)?.errors || [];
export const getLoading = (state) => !!getUIContext(state)?.loading;
export const getPageTitle = (state) => getUIContext(state)?.pageTitle || null;
export const getFilterModal = (state) => !!getUIContext(state)?.filterModal;
